// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-typography{
    font-family: "Poppins" !important;
}
.top-pick-text {
    font-size: clamp(8px, 1.5vw, 12px);
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
  }
  .skeletonImage .ant-skeleton{
    width: 70%;
  }

  .product-card-skeleton-mobile .ant-card-cover {
    margin-top:6px!important;
    height: 100px;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .product-card-skeleton .ant-card-cover {
    margin-top:6px!important;
    height: 150px;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .ant-card-cover {
    margin-top:6px!important;
    height: 83px;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .top-pick-card .ant-typography {
    font-size: 12px;
  }
  .comparison-product-card-label-border{
    border:0px;
  }
  .comparison-product-card {
    /* flex: 1 1 0; */
    margin: 0;
    /* width: clamp(70px, 26%, 150px); */
    border-radius: 8px 8px 0px 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: transparent;
    margin-right:2px!important;
  }

  .comparison-product-card .ant-card-body {
    /* padding: clamp(6px, 12.5%, 12px); */
    /* padding:0px 20px; */
    padding:0px 0px;

    flex-grow: 1;
    display: flex;
    justify-content: space-between;
  }

  .comparison-product-card.highlighted {
    /* border: 2px solid #005cff; */
    /* border: 2px solid #005cff; */

    border-bottom: #ffffff;
  }
  .comparison-card-cover {
    text-align: center;
    /* padding: clamp(0px, 1%, 16px); */
    position: relative;
  }

  .comaprisonLabel{
    /* width:115px; */
    width:70px;

  }
  .comaprisonLabel2{
    width:100px;
  }

  @media (max-width: 599px) {
    .top-pick-text {
      font-size: 7px;
      -webkit-line-clamp: 2;
    }
    .top-pick-card .ant-typography {
      font-size: 7px;
    }
  }

  @media (max-width: 992px) {
    .comparison-product-card .ant-card-body {
      padding: 0px;
    }
    .comparison-card-cover {
    padding: 0px;
  }
  }

  @media(min-width: 1000px){
    .comaprisonLabel{
      width:155px;
    }
  }

  .comparison-product-card {
  /* border: 2px solid #005cff; */
  border-bottom: none;
  position: relative;
}

.comparison-product-card::before {
  content: '';
  position: absolute;
  bottom: 0;
  left: -2px;
  width: 2px;
  height: 24px;
  background: #ffffff;
}

.comparison-product-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: -2px;
  width: 2px;
  height: 24px;
  background: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/common/ComparisonCard.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;AACrC;AACA;IACI,kCAAkC;IAClC,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;EACvB;EACA;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,SAAS;IACT,oCAAoC;IACpC,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,sCAAsC;IACtC,sBAAsB;IACtB,eAAe;;IAEf,YAAY;IACZ,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;IAC/B,+BAA+B;;IAE/B,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,UAAU;;EAEZ;EACA;IACE,WAAW;EACb;;EAEA;IACE;MACE,cAAc;MACd,qBAAqB;IACvB;IACA;MACE,cAAc;IAChB;EACF;;EAEA;IACE;MACE,YAAY;IACd;IACA;IACA,YAAY;EACd;EACA;;EAEA;IACE;MACE,WAAW;IACb;EACF;;EAEA;EACA,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".ant-typography{\n    font-family: \"Poppins\" !important;\n}\n.top-pick-text {\n    font-size: clamp(8px, 1.5vw, 12px);\n    color: #333;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n  }\n  .skeletonImage .ant-skeleton{\n    width: 70%;\n  }\n\n  .product-card-skeleton-mobile .ant-card-cover {\n    margin-top:6px!important;\n    height: 100px;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n  }\n  .product-card-skeleton .ant-card-cover {\n    margin-top:6px!important;\n    height: 150px;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n  }\n\n  .ant-card-cover {\n    margin-top:6px!important;\n    height: 83px;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n  }\n\n  .top-pick-card .ant-typography {\n    font-size: 12px;\n  }\n  .comparison-product-card-label-border{\n    border:0px;\n  }\n  .comparison-product-card {\n    /* flex: 1 1 0; */\n    margin: 0;\n    /* width: clamp(70px, 26%, 150px); */\n    border-radius: 8px 8px 0px 0px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: transparent;\n    margin-right:2px!important;\n  }\n\n  .comparison-product-card .ant-card-body {\n    /* padding: clamp(6px, 12.5%, 12px); */\n    /* padding:0px 20px; */\n    padding:0px 0px;\n\n    flex-grow: 1;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .comparison-product-card.highlighted {\n    /* border: 2px solid #005cff; */\n    /* border: 2px solid #005cff; */\n\n    border-bottom: #ffffff;\n  }\n  .comparison-card-cover {\n    text-align: center;\n    /* padding: clamp(0px, 1%, 16px); */\n    position: relative;\n  }\n\n  .comaprisonLabel{\n    /* width:115px; */\n    width:70px;\n\n  }\n  .comaprisonLabel2{\n    width:100px;\n  }\n\n  @media (max-width: 599px) {\n    .top-pick-text {\n      font-size: 7px;\n      -webkit-line-clamp: 2;\n    }\n    .top-pick-card .ant-typography {\n      font-size: 7px;\n    }\n  }\n\n  @media (max-width: 992px) {\n    .comparison-product-card .ant-card-body {\n      padding: 0px;\n    }\n    .comparison-card-cover {\n    padding: 0px;\n  }\n  }\n\n  @media(min-width: 1000px){\n    .comaprisonLabel{\n      width:155px;\n    }\n  }\n\n  .comparison-product-card {\n  /* border: 2px solid #005cff; */\n  border-bottom: none;\n  position: relative;\n}\n\n.comparison-product-card::before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: -2px;\n  width: 2px;\n  height: 24px;\n  background: #ffffff;\n}\n\n.comparison-product-card::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  right: -2px;\n  width: 2px;\n  height: 24px;\n  background: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
